import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import jwt_decode from 'jwt-decode';
import { GlobalStorage } from '../../core/services/globals.service';

import {
  getDateformatMonthYearString,
  getNextMonthDate,
} from 'src/app/apv/core/utils/functions';
import { toClp } from '../../core/utils/formatters';
import { DOCUMENT } from '@angular/common';
import { Util } from 'src/app/shared/common/utils/util';

@Component({
    selector: 'successful-modifcation',
    templateUrl: './successful-modifcation.component.html',
    styleUrls: ['./successful-modifcation.component.scss'],
    standalone: false
})
export class SuccessfulMoficationComponent implements OnInit,AfterViewInit {
  public finalAmount: any = {};
  public today: any;
  public currentDate = new Date();
  public currentMonth =
    this.currentDate.getMonth() + 1 < 10
      ? `0${this.currentDate.getMonth() + 1}`
      : this.currentDate.getMonth() + 1;
  public currentDay =
    this.currentDate.getDate() < 10
      ? `0${this.currentDate.getDate()}`
      : this.currentDate.getDate();
  public currentYear = this.currentDate.getFullYear();
  public nextMonth: Date = getNextMonthDate(this.currentDate);
  public nextMonthInSpanish: string = getDateformatMonthYearString(
    this.nextMonth
  );
  public isMobile = false;
  user: any;
  public downloadButtonLabel = 'Descargar comprobante';

  constructor(
    private readonly router: Router,
    private readonly globalSvc: GlobalStorage,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly util: Util
  ) {
    this.isMobile = (this.document.defaultView as any).Capacitor;
  }

  ngAfterViewInit() {
    const botDiv = document.getElementById('botDiv');
    const content = document.querySelector('.success-container');
  
    if (botDiv && content) {
      content.classList.add('with-bot');
    }
  }
  
  async ngOnInit() {
    this.today = new Date();

    this.finalAmount = JSON.parse(
      String(sessionStorage.getItem('finalAmount'))
    );

    this.getUserDataFromToken();

    if (!this.finalAmount) this.redirectToHome();

    console.log(`this.amountModification`, this.finalAmount);
  }

  private redirectToHome() {
    this.router.navigate(['/home/ccv/home']);
  }

  private readonly getUserDataFromToken = () => {
    try {
      const token = this.globalSvc;
      const decodedToken: any = jwt_decode(token.token);

      this.user = {
        name: decodedToken.name,
        lastName: decodedToken.lastName,
        rut: decodedToken.user_id,
        email: decodedToken.email,
      };
      this.util.levantarEncuesta('Modificar-suscripcion-APV');

    } catch (error) {
      console.error('Error getting user data from token');
      console.log(error);
    }
  };

  // format date to dd/mm/yyyy
  public formatDate(date: Date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  savesBySubscription() {
    return this.currencyByAmountAndCurrencyCode(
      this.finalAmount.discountValue,
      this.finalAmount.discountType
    );
  }
  private currencyByAmountAndCurrencyCode(
    amount: number,
    currencyCode: string
  ) {
    switch (currencyCode) {
      case 'P':
        return `$ ${this.numberToCurrency(amount)}`;
      case 'U':
        return `${this.numberToCurrency(amount)} UF`;
      case 'R':
        return `${this.numberToCurrency(amount)} %`;
      default:
        return '';
    }
  }
  public numberToCurrency(number: number) {
    if (number) {
      const numberString = toClp(number);
      return numberString;
    }
    return '';
  }

  public downloadMyFile() {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute(
      'href',
      `data:application/pdf;base64,${this.finalAmount.pdf.content}`
    );
    link.setAttribute('download', `comprobante_modificacion.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  onResize(event: any) {
    if (event.target.innerWidth < 1200) {
      this.downloadButtonLabel = 'Comprobante';
    } else {
      this.downloadButtonLabel = 'Descargar comprobante';
    }
  }

  public riskByFund(fund: string) {
    switch (fund) {
      case 'A':
        return 'Más riesgoso';
      case 'B':
        return 'Riesgoso';
      case 'C':
        return 'Intermedio';
      case 'D':
        return 'Conservador';
      case 'E':
        return 'Más conservador';
      default:
        return '';
    }
  }
}
